import React from 'react'
import PropTypes from 'prop-types'
import { AddToTrolley, BackToTop, Breadcrumb, ErrorBoundary } from '@sainsburys-tech/bolt'
import Lister from '../../containers/Lister/Lister'
import { CategoryHelper } from '../../helpers/CategoryHelper'
import { searchTypes } from '../../config'
import findabilityDecoder from '../../helpers/FindabilityDecoder'

import ErrorPage from '../ErrorPage/ErrorPage'
import CategoryList from '../../containers/CategoryList/CategoryList'
import NoResultsSuggestions from '../../containers/NoResultsSuggestions/NoResultsSuggestions'

class ListerPage extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleBreadcrumbClick = this.handleBreadcrumbClick.bind(this)
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.pageType !== this.props.pageType) return true
    if (nextProps.searchTerm !== this.props.searchTerm) return true
    if (nextProps.showErrorPage !== this.props.showErrorPage) return true
    if (nextProps.isClearance !== this.props.isClearance) return true
    if (nextProps.appliedSortBy !== this.props.appliedSortBy) return true
    if (JSON.stringify(nextProps.products) !== JSON.stringify(this.props.products)) return true
    if (JSON.stringify(nextProps.categoryAncestors) !== JSON.stringify(this.props.categoryAncestors)) return true
    return false
  }

  componentDidUpdate() {
    if (this.props.filterModalVisible !== true) {
      this.setFocusToTop()
    }
  }

  setFocusToTop() {
    // setTimeout hack is for the VoiceOver screen reader
    setTimeout(function() {
      document.getElementById('app').focus()
    }, 0)
  }

  handleBreadcrumbClick(event, attrs = {}) {
    const { updateDestinationPageType } = this.props
    if (!attrs.isHome && attrs.path) {
      event.preventDefault()
      updateDestinationPageType({ type: 'CLP' })
      this.context.navigateTo(attrs.path)
    }
  }

  render() {
    const {
      isPopulated,
      showErrorPage,
      products,
      meta,
      categoryAncestors,
      searchTerm,
      searchType,
      pageType,
      categoryName,
      isPlp,
      isPlpPlus,
      isPlpPlusDescendant,
      isClearance,
      isCannedSearch
    } = this.props

    if (isCannedSearch === false && pageType === 'canned' && meta.totalData > 0) {
      return <NoResultsSuggestions />
    }

    const invalidListPage = !isPopulated || showErrorPage
    let component
    if (invalidListPage) {
      component = <ErrorPage failureStatus={this.props.failureStatus ? this.props.failureStatus : 404} />
    } else {
      component = products ? <Lister {...this.props} /> : <CategoryList {...this.props} />
    }
    const isValidBreadcrumb =
      (searchType !== searchTypes.brandsNIC &&
        searchType !== searchTypes.NRS &&
        products &&
        !!meta &&
        !meta.categoryMatch &&
        categoryAncestors.length > 0) ||
      (!products && categoryAncestors.length > 0)
    const showBreadcrumbHomeLink =
      (!products && !!categoryAncestors && categoryAncestors.length > 0) ||
      isPlp ||
      isPlpPlus ||
      isPlpPlusDescendant ||
      isClearance
    const sanitisedSearchTerm = searchTerm ? findabilityDecoder.getSanitised(searchTerm) : ''
    const breadcrumbAncestors =
      isValidBreadcrumb &&
      CategoryHelper.getBreadcrumbAncestors(
        categoryAncestors,
        sanitisedSearchTerm,
        searchType,
        isClearance,
        isCannedSearch,
        categoryName
      )
    return (
      <ErrorBoundary>
        <div role='main'>
          <AddToTrolley.Modal className='font-standard' />
          <BackToTop />
          {isValidBreadcrumb && !invalidListPage && (
            <div className='xs-auto--negative sm-auto--none search-breadcrumb'>
              <ErrorBoundary>
                <Breadcrumb
                  metaData={!searchTerm}
                  showHomeLink={showBreadcrumbHomeLink}
                  currentPageName={!searchTerm ? categoryName : ''}
                  ancestors={breadcrumbAncestors}
                  onClick={this.handleBreadcrumbClick}
                />
              </ErrorBoundary>
            </div>
          )}
          <ErrorBoundary>{component}</ErrorBoundary>
        </div>
      </ErrorBoundary>
    )
  }
}

ListerPage.defaultProps = {
  categoryAncestors: [],
  filters: [],
  match: {},
  searchType: null,
  categoryName: '',
  filterModalVisible: false,
  meta: {},
  products: [],
  searchTerm: '',
  failureStatus: null,
  isPopulated: false,
  showErrorPage: false,
  isPlp: false,
  isPlpPlus: false,
  isPlpPlusDescendant: false,
  isClearance: false,
  isCannedSearch: false,
  results: null,
  categoryNameFromFilter: '',
  dfp: {},
  updateDestinationPageType: () => {},
  pageType: '',
  appliedSortBy: {}
}

ListerPage.propTypes = {
  match: PropTypes.object,
  searchType: PropTypes.string,
  categoryAncestors: PropTypes.array,
  categoryChildren: PropTypes.array.isRequired,
  categoryName: PropTypes.string,
  filterModalVisible: PropTypes.bool,
  filters: PropTypes.array,
  meta: PropTypes.object,
  products: PropTypes.array,
  searchTerm: PropTypes.string,
  failureStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isPopulated: PropTypes.bool,
  showErrorPage: PropTypes.bool,
  isPlp: PropTypes.bool,
  isPlpPlus: PropTypes.bool,
  isPlpPlusDescendant: PropTypes.bool,
  isClearance: PropTypes.bool,
  isCannedSearch: PropTypes.bool,
  results: PropTypes.number,
  categoryNameFromFilter: PropTypes.string,
  dfp: PropTypes.object,
  updateDestinationPageType: PropTypes.func,
  pageType: PropTypes.string,
  appliedSortBy: PropTypes.object
}

ListerPage.contextTypes = {
  navigateTo: PropTypes.func
}

export default ListerPage
